import { getStateFromPath } from '@react-navigation/native';
import { DecodedSpecialUrlCode, SpecialUrlCode } from '../../urlCodeHelpers';
import { AbstractPathResolver, PathResolveResult } from '../PathResolver';

export class PopClipV1PathResolver extends AbstractPathResolver {
  resolveStateFromPath(): PathResolveResult {
    const { urlPath, options } = this.context;
    if (SpecialUrlCode.isPopClipV1(urlPath)) {
      const { sellerId, clipId } =
        DecodedSpecialUrlCode.decodePopClipV1(urlPath);
      return this.parseQs(
        getStateFromPath(`/popclip_v1/${sellerId}/${clipId}`, options),
      );
    }
  }
}
